// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "viewer-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-1zThpkd0_mjs":"33fb0b954674941e2c2e","filerobot":"5049cacf658ec2ffd037","plyr":"d498ae822a1ae5475b3d","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-cOp1W5mL_mjs":"50a4e6dbe2215c6c4ca6"}[chunkId] + "";
};